import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _FixedAssetItemReportColumn, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { MASK_BOOLEAN_ICON, MASK_NUMBER } from "../../../../../theme/Component/BasicMultiSelecTable";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../theme/Component/Modal";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";


const RECORDS_PER_PAGE = 15;

export const FixedAssetItemReportColumn = () => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_FixedAssetItemReportColumn);
    const paginador = usePaginator();
    const modalEdit = useModal("Editar columna del reporte", MODAL_md);

    const [isEnabled, setIsEnabled] = useState<boolean | null>(null);
    const [regexStr, setRegexStr] = useState("");

    const head = [
        { title: "ID", property: "IDFixedAssetItemReportColumn", visible: true, mask: MASK_NUMBER },
        { title: "Nombre Columna", property: "ColumnName", visible: true },
        { title: "Orden de Columna Nativa", property: "ColumnIndex", visible: true, mask: MASK_NUMBER },
        { title: "Tag", property: "ColumnTag", visible: true },
        { title: "Orden en Reporte Usuario", property: "OrderColumn", visible: true, mask: MASK_NUMBER },
        { title: "Habilitado", property: "IsEnabled", visible: true, mask: MASK_BOOLEAN_ICON },
    ];

    useEffect(() => {
        getLista();
    }, [paginador.page]);

    const getLista = () => {
        instance.getFixedAssetItemReportColumnEnabled(isEnabled, regexStr.trim() || null, paginador.page, RECORDS_PER_PAGE).then((resp: any) => {
            if (!resp) return;
            paginador.setPages(resp.NumberOfPages ?? 0);
            paginador.setRecords(resp.NumberOfRecords ?? (resp.NumberOfPages ?? 0) * RECORDS_PER_PAGE);
            paginador.setRegiPerPage(RECORDS_PER_PAGE);
            setLista(resp.List ?? []);
        }).catch((err: any) => {
            toast.error(err);
            setLista([]);
        });
    };

    const search = () => {
        if (paginador.page !== 1) {
            paginador.setPage(1);
            return;
        }
        getLista();
    };

    const createDefaultReport = () => {
        instance.createFixedAssetItemReportColumn(null).then(
            (resp: boolean) => {
                if (resp) {
                    toast.success("Reporte por defecto Creado")
                };

            }
        ).catch((err: any) => {
            toast.error(err);
        });
    };

    const actionsDropDown = [
        { id: 1, name: "Crear Reporte por Defecto", permiso: null, activo: true },
    ];

    const actions = (action: any) => {
        if (action.id === 1) {
            createDefaultReport();
        }
    };

    const buttons = () => (
        <div className="row">
            <div className="col-md-12">
                <DropDown lista={actionsDropDown} eventClick={actions} />
            </div>
        </div>
    );

    const updateReportColumn = () => {
        instance.bean = bean;
        instance.updateFixedAssetItemReportColumn(bean).then(
            () => {
                toast.success("Columna del reporte actualizada");
                modalEdit.close();
                getLista();
            }
        ).catch((err: any) => {
            toast.error(err);
        });
    };

    const listaBotones = () => (
        <ListMenu listaBotones={[
            {
                titulo: "Editar",
                icono: "ri-edit-2-line",
                visible: _single.canEdit(),
                evento: () => modalEdit.open(`Editar ${bean.ColumnName ?? "columna"}`),
            },
        ]} />
    );

    return (
        <BasicPage titulo="Configuración de Reporte de Activos Fijos">
            <div className="row align-items-end">
                <div className="col-md-6">
                    <label>Búsqueda por texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(event) => setRegexStr(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") search(); }} />
                </div>

                <div className="col-md-3">
                    <label>Habilitado en reporte</label>
                    <select
                        className="form-select"
                        value={isEnabled === null ? "" : String(isEnabled)}
                        onChange={(event) => {
                            const value = event.target.value;
                            setIsEnabled(value === "" ? null : value === "true");
                        }}
                    >
                        <option value="">...</option>
                        <option value="true">Sí</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="col-md-3">
                    <BasicButton icon="ri-search-line" eventClick={search} > Buscar </BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} headButtons={buttons()} listButtons={listaBotones()} rowSet={setBean} records={paginador} />
                </div>
            </div>

            <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={updateReportColumn}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch
                            label="Habilitado"
                            estado={bean.IsEnabled ?? false}
                            eventChange={(value) => setBean({ ...bean, IsEnabled: value })}
                        />
                    </div>
                    <div className="col-md-12">
                        <label>Orden en Reporte Usuario</label>
                        <input
                            type="number"
                            className="form-control"
                            value={bean.OrderColumn ?? ""}
                            onChange={(event) => setBean({
                                ...bean,
                                OrderColumn: event.target.value === "" ? null : Number(event.target.value),
                            })}
                        />
                    </div>
                </div>
            </Modal>
        </BasicPage>
    );
};
